"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInboxLogic = void 0;
var utils_1 = require("../util/utils");
function createInboxLogic(store, profileLogic, utilityLogic, containerLogic, aclLogic) {
    function createInboxFor(peerWebId, nick) {
        return __awaiter(this, void 0, void 0, function () {
            var myWebId, podRoot, ourInbox, aclDocUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, profileLogic.loadMe()];
                    case 1:
                        myWebId = _a.sent();
                        return [4 /*yield*/, profileLogic.getPodRoot(myWebId)];
                    case 2:
                        podRoot = _a.sent();
                        ourInbox = "".concat(podRoot.value, "p2p-inboxes/").concat(encodeURIComponent(nick), "/");
                        return [4 /*yield*/, containerLogic.createContainer(ourInbox)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, aclLogic.findAclDocUrl(ourInbox)];
                    case 4:
                        aclDocUrl = _a.sent();
                        return [4 /*yield*/, utilityLogic.setSinglePeerAccess({
                                ownerWebId: myWebId.value,
                                peerWebId: peerWebId,
                                accessToModes: 'acl:Append',
                                target: ourInbox
                            })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, ourInbox];
                }
            });
        });
    }
    function getNewMessages(user) {
        return __awaiter(this, void 0, void 0, function () {
            var inbox, urls;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!user) return [3 /*break*/, 2];
                        return [4 /*yield*/, profileLogic.loadMe()];
                    case 1:
                        user = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, profileLogic.getMainInbox(user)];
                    case 3:
                        inbox = _a.sent();
                        return [4 /*yield*/, containerLogic.getContainerMembers(inbox.value)];
                    case 4:
                        urls = _a.sent();
                        return [2 /*return*/, urls.filter(function (url) { return !containerLogic.isContainer(url); })];
                }
            });
        });
    }
    function markAsRead(url, date) {
        return __awaiter(this, void 0, void 0, function () {
            var downloaded, archiveUrl, options, uploaded;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, store.fetcher._fetch(url)];
                    case 1:
                        downloaded = _b.sent();
                        if (downloaded.status !== 200) {
                            throw new Error("Not OK! ".concat(url));
                        }
                        archiveUrl = (0, utils_1.getArchiveUrl)(url, date);
                        _a = {
                            method: 'PUT'
                        };
                        return [4 /*yield*/, downloaded.text()];
                    case 2:
                        options = (_a.body = _b.sent(),
                            _a.headers = [
                                ['Content-Type', downloaded.headers.get('Content-Type') || 'application/octet-stream']
                            ],
                            _a);
                        return [4 /*yield*/, store.fetcher._fetch(archiveUrl, options)];
                    case 3:
                        uploaded = _b.sent();
                        if (!(uploaded.status.toString()[0] === '2')) return [3 /*break*/, 5];
                        return [4 /*yield*/, store.fetcher._fetch(url, {
                                method: 'DELETE'
                            })];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return {
        createInboxFor: createInboxFor,
        getNewMessages: getNewMessages,
        markAsRead: markAsRead
    };
}
exports.createInboxLogic = createInboxLogic;
//# sourceMappingURL=inboxLogic.js.map